<template>
  <!-- <v-list-group @click="() => $emit('select', date[0])"> -->
  <!-- <div v-if="summary">
    <v-list-group sub-group @click="() => $emit('select', date, meeting.meetings[0])">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title class="race_menu_item">
            <span>{{ formattedDate }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <v-list-item v-for="race in races" :key="race.id">
        <Race :race="race" :meeting="meetingR"/>
      </v-list-item>
    </v-list-group>
  </div> -->
  <div>
    <v-list-item @click="() => $emit('select', date, meetingDate)" :style="selectedRaceDate">
      <v-list-item-content>
        <v-list-item-title class="race_menu_item">
          <span>{{ formattedDate }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { format, parse } from 'date-fns'
import numeral from 'numeral'
import { mapActions, mapState } from 'vuex'
// import Race from '../Race'

export default {
  name: 'Date',
  components: {
    // Race,
  },
  computed: {
    ...mapState(['selectedMeeting', 'selectedRace']),
    competitors () {
      return this.race?.runners
    },
    dates () {
      return this.date
    },
    meetingDate () {
      const meetings = this.meeting
      const formattedMeeting = []
      meetings.meetings.forEach((b) => {
        if (b.meetingDate === this.date) {
          formattedMeeting.push(b)
        }
        return formattedMeeting
      })
      return formattedMeeting[0]
    },
    meetingR () {
      return this.meeting.meetings[0]
    },
    formattedDate () {
      const dateObj = parse(this.date, 'yyyy-MM-dd HH:mm:ss', new Date())
      return format(dateObj, 'do MMM yyyy')
    },
    selectedRaceDate () {
      if (this.date) {
        /* eslint-disable camelcase */
        if (`${this.date}+${this.meetingDate?.meetingId}` === `${this.selectedMeeting?.meetingDate}+${this.selectedMeeting?.meetingId}`) return 'background:rgb(233, 10, 124, 0.5);'
        return ''
      }
      return ''
    }
  },
  data () {
    return {
      numeral,
      format
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    date: {
      type: String
    },
    races: {
      type: Array,
      default: () => []
    },
    meeting: {
      type: Object,
      default: () => {}
    },
    summary: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(['setSelectedRace', 'fetchBets'])
  }
}
</script>

<style scoped>
.race_menu_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
